module.exports = __webpack_public_path__ + "img/案例2.f777df09.png";